(function() {
  if (window.shCollectionCardsBound) return;
  window.shCollectionCardsBound = true;
  var initialized = new WeakSet();
  var originalImages = new WeakMap();
  var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 769px)') : { matches: false };

  var mobileOpen = null;
  var mobileId = 0;
  function closeMobile(restoreFocus) {
    if (!mobileOpen) return;
    var card = mobileOpen;
    mobileOpen = null;
    card.classList.remove('sh-mobile-sizes-open');
    var trigger = card.querySelector('[data-sh-mobile-quick-add]');
    trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && trigger.isConnected) trigger.focus();
  }

  function mobile(card) {
    if (mobileOpen && !mobileOpen.isConnected) closeMobile(false);
    var trigger = card.querySelector('[data-sh-mobile-quick-add]');
    var desktop = card.querySelector('[data-sh-complete-open]');
    if (!trigger || !desktop || desktop.hidden) return;
    if (trigger.hidden) trigger.hidden = false;
    var overlay = card.querySelector('[data-sh-hover-proxy]');
    if (!overlay || !overlay.querySelector('[data-sh-hover-controls]:not([hidden])')) { if (!trigger.hidden) trigger.hidden = true; return; }
    if (!overlay.id) {
      do { mobileId += 1; } while (document.getElementById('ShMobileSizes-' + mobileId));
      overlay.id = 'ShMobileSizes-' + mobileId;
    }
    trigger.setAttribute('aria-controls', overlay.id);
    var source = card.querySelector('[data-sh-complete-card] [data-sh-size-feedback]');
    var feedback = overlay.querySelector('[data-sh-mobile-feedback]');
    if (source && feedback) {
      if (feedback.textContent !== source.textContent) feedback.textContent = source.textContent;
      if (feedback.hidden !== source.hidden) feedback.hidden = source.hidden;
    }
    var cart = card.querySelector('[data-sh-complete-card] [data-sh-size-view-cart]');
    var recovery = overlay.querySelector('[data-sh-mobile-cart]');
    if (cart && recovery && recovery.hidden !== cart.hidden) recovery.hidden = cart.hidden;
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest && event.target.closest('[data-sh-mobile-quick-add]');
    if (trigger && !finePointer.matches) {
      var card = trigger.closest('.sh-clean-card');
      var overlay = card.querySelector('[data-sh-hover-proxy]');
      if (mobileOpen === card) { closeMobile(true); schedule(); return; }
      closeMobile(false);
      if (overlay) {
        mobileOpen = card;
        card.classList.add('sh-mobile-sizes-open');
        trigger.setAttribute('aria-expanded', 'true');
        var first = overlay.querySelector('[data-sh-mobile-choice]:not(:disabled), [data-sh-hover-size]:not(:disabled), [data-sh-mobile-close]');
        if (first) first.focus({preventScroll:true});
      }
      schedule();
      return;
    }
    if (event.target.closest && event.target.closest('[data-sh-mobile-close]')) { closeMobile(true); schedule(); return; }
    if (mobileOpen && !mobileOpen.contains(event.target)) { closeMobile(false); schedule(); }
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && mobileOpen) { event.preventDefault(); closeMobile(true); schedule(); }
  });
  document.addEventListener('ajaxProduct:added', function(event) {
    if (mobileOpen && event.detail && mobileOpen.contains(event.detail.form)) { closeMobile(false); schedule(); }
  });
  if (finePointer.addEventListener) finePointer.addEventListener('change', function() { closeMobile(false); schedule(); });

  function rating(root) {
    var source = root.querySelector('[data-sh-rating-source] [data-average-rating][data-number-of-reviews]');
    if (!source) return;
    var score = Number(source.getAttribute('data-average-rating'));
    var count = Number(source.getAttribute('data-number-of-reviews'));
    var link = root.querySelector('[data-sh-rating-link]');
    if (!link) return;
    var valid = Number.isFinite(score) && score > 0 && score <= 5 && Number.isInteger(count) && count > 0;
    if (link.hidden !== !valid) link.hidden = !valid;
    if (!valid) return;
    var value = Math.round(score * 10) / 10;
    var label = root.getAttribute('data-sh-rating-label').replace('[rating]', value).replace('[scale]', '5').replace('[count]', count);
    if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    var stars = root.querySelector('[data-sh-rating-stars]');
    var fill = (score * 20) + '%';
    if (stars.style.getPropertyValue('--sh-rating-fill') !== fill) stars.style.setProperty('--sh-rating-fill', fill);
    var number = root.querySelector('[data-sh-rating-number]');
    var text = value + ' (' + count + ')';
    if (number.textContent !== text) number.textContent = text;
  }

  function preview(card, swatch) {
    card.querySelectorAll('[data-sh-card-swatch]').forEach(function(button) { button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false'); });
    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask) return;
    var previous = mask.querySelector('[data-sh-card-preview]');
    if (previous) previous.remove();
    (originalImages.get(card) || []).forEach(function(entry) {
      if (swatch) entry[0].setAttribute('aria-hidden', 'true');
      else if (entry[1] === null) entry[0].removeAttribute('aria-hidden');
      else entry[0].setAttribute('aria-hidden', entry[1]);
    });
    var pickerImage = mask.querySelector('[data-sh-selected-image]');
    if (pickerImage) {
      if (swatch) pickerImage.setAttribute('aria-hidden', 'true');
      else pickerImage.removeAttribute('aria-hidden');
    }
    if (!swatch) return;
    var chosen = card.querySelector('[data-sh-complete-form]:not([hidden])');
    var source = chosen && chosen.getAttribute('data-sh-choice-image') || swatch.getAttribute('data-sh-image');
    var alt = chosen && chosen.getAttribute('data-sh-choice-image-alt') || swatch.getAttribute('data-sh-image-alt');
    if (!source) {
      var normalize = function(value) { return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
      var color = swatch.getAttribute('data-sh-color');
      var colorValues = Array.from(card.querySelectorAll('[data-sh-card-swatch]')).map(function(button) { return button.getAttribute('data-sh-color'); });
      var photos = Array.from(card.querySelectorAll('[data-sh-gallery-image]'));
      var photo = photos.find(function(button) { return button.getAttribute('data-sh-image-group') === 'color_' + normalize(color) || button.getAttribute('data-sh-image-group') === 'colour_' + normalize(color); });
      if (!photo) photo = photos.find(function(button) {
        var words = ' ' + normalize(button.getAttribute('data-sh-alt') || '').replace(/-/g, ' ') + ' ';
        var matches = colorValues.filter(function(value) { return words.includes(' ' + normalize(value).replace(/-/g, ' ') + ' '); });
        return matches.length === 1 && matches[0] === color;
      });
      if (photo) { source = photo.getAttribute('data-sh-src'); alt = photo.getAttribute('data-sh-alt'); }
    }
    var variant = chosen ? chosen.querySelector('[name="id"]').value : swatch.getAttribute('data-sh-variant');
    var layer = document.createElement('div');
    layer.className = 'sh-card-preview-image';
    layer.setAttribute('data-sh-card-preview', '');
    var label = document.createElement('span');
    label.textContent = alt;
    layer.appendChild(label);
    var image = document.createElement('img');
    image.alt = label.textContent;
    var url;
    try { url = new URL(source, location.href); } catch (_) {}
    if (source && url && /^https?:$/.test(url.protocol)) {
      image.hidden = true;
      image.addEventListener('load', function() { if (image.isConnected) { label.hidden = true; image.hidden = false; } });
      image.addEventListener('error', function() { image.hidden = true; label.hidden = false; });
      layer.appendChild(image);
      image.src = url.href;
    }
    mask.appendChild(layer);
    card.querySelectorAll('a.grid-product__link').forEach(function(link) {
      var target = new URL(link.href, location.href);
      if (target.origin !== location.origin) return;
      target.searchParams.set('variant', variant);
      link.href = target.pathname + target.search + target.hash;
    });
  }

  function scan(root) {
    if (mobileOpen && !mobileOpen.isConnected) closeMobile(false);
    var cards = root.matches && root.matches('.sh-clean-card') ? [root] : [];
    if (root.querySelectorAll) cards = cards.concat(Array.from(root.querySelectorAll('.sh-clean-card')));
    cards.forEach(function(card) {
      if (!initialized.has(card)) {
        initialized.add(card);
        originalImages.set(card, Array.from(card.querySelectorAll('.grid-product__image-mask img')).filter(function(img) { return !img.closest('[data-sh-selected-image],[data-sh-card-preview]'); }).map(function(img) { return [img, img.getAttribute('aria-hidden')]; }));
        card.classList.add('sh-card-enhanced');
      }
      var forms = Array.from(card.querySelectorAll('[data-sh-complete-form]'));
      if (forms.length) card.querySelectorAll('[data-sh-card-swatch]').forEach(function(button) {
        var index = Number(button.getAttribute('data-sh-option-index'));
        var available = forms.some(function(form) {
          if (form.hasAttribute('data-sh-stock-unavailable')) return false;
          try { return JSON.parse(form.getAttribute('data-sh-option-values'))[index] === button.getAttribute('data-sh-color'); } catch (_) { return false; }
        });
        button.disabled = !available;
        if (!available && button.getAttribute('aria-pressed') === 'true') preview(card, null);
      });
      card.querySelectorAll('[data-sh-card-rating]').forEach(rating);
      mobile(card);
    });
  }

  document.addEventListener('click', function(event) {
    var swatch = event.target.closest && event.target.closest('[data-sh-card-swatch]');
    if (!swatch || swatch.disabled) return;
    var card = swatch.closest('.sh-clean-card');
    if (!card) return;
    var select = card.querySelector('[data-sh-option-select="' + swatch.getAttribute('data-sh-option-index') + '"]');
    if (select && !select.disabled) {
      select.value = swatch.getAttribute('data-sh-color');
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    preview(card, swatch);
  });
  document.addEventListener('change', function(event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-sh-option-select]')) return;
    var card = select.closest('.sh-clean-card');
    if (!card) return;
    var swatches = Array.from(card.querySelectorAll('[data-sh-card-swatch]'));
    var colorIndex = swatches[0] && swatches[0].getAttribute('data-sh-option-index');
    var colorSelect = colorIndex !== undefined && card.querySelector('[data-sh-option-select="' + colorIndex + '"]');
    var selected = colorSelect && swatches.find(function(button) { return button.getAttribute('data-sh-color') === colorSelect.value && !button.disabled; });
    preview(card, selected || null);
  });
  document.addEventListener('submit', function(event) {
    var overlay = event.target.closest && event.target.closest('[data-sh-card-overlay]');
    if (!overlay || finePointer.matches || overlay.closest('.sh-clean-card') === mobileOpen) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(function() { scheduled = false; scan(document); });
  }
  scan(document);
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'data-sh-stock-unavailable', 'hidden'] });
})();
